import React from 'react'
import { createUseStyles } from 'react-jss'

import Select from 'react-select'
import { theme as localTheme } from '../theme'

const FormSelect = ({
  inputName,
  noSearch,
  optionsArray,
  placeholder,
  defaultValue,
  error,
  onChange,
  greyBackground,
  onClear,
}) => {
  const colourStyles = {
    control: styles => ({
      ...styles,
      backgroundColor: greyBackground ? '#f7f7f7' : 'white',
      border: greyBackground ? '1px solid #f7f7f7' : '1px solid #ddd',
      fontSize: 12,
      borderRadius: 17,
      outline: 'none !important',
      boxShadow: '0 !important',
      '&:hover': {
        border: greyBackground ? '1px solid #f7f7f7' : '1px solid #ddd',
        outline: 'none !important',
      },
      '&:active': {
        border: greyBackground ? '1px solid #f7f7f7' : '1px solid #ddd',
        outline: 'none !important',
      },
    }),
    option: (styles, { isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isDisabled
          ? null
          : isSelected
          ? localTheme.colors.sunflower
          : isFocused
          ? null
          : null,
        color: '#4E4E4E',
        cursor: isDisabled ? 'not-allowed' : 'default',
        fontSize: '14px',
        fontWeight: isSelected ? 500 : 300,
        lineHeight: '19px',
        paddingLeft: 25,
        ':active': {
          ...styles[':active'],
          backgroundColor: localTheme.colors.sunflower,
        },
        ':hover': {
          ...styles[':hover'],
          backgroundColor: localTheme.colors.sunflower,
        },
      }
    },
    container: () => ({
      borderRadius: 17,
      position: 'relative',
      boxSizing: 'border-box',
    }),
    dropdownIndicator: base => ({
      ...base,
      color: localTheme.colors.main,
      ':hover': {
        color: localTheme.colors.main,
      },
    }),
    valueContainer: () => ({
      backgroundColor: 'transparent',
      border: 'none',
      boxShadow: 'none',
      padding: '10px 20px',
      fontSize: 12,
      borderRadius: 17,
      overflow: 'hidden',
      height: 48,
      boxSizing: 'border-box',
    }),
    placeholder: () => ({
      color: '#000',
      paddingTop: '8px',
    }),
  }

  const useStyles = createUseStyles({
    labelWrapper: {
      width: '100%',
      display: 'block',
      '& .select__control--menu-is-open': {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
      },
      '& .select__menu': {
        marginTop: 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
      },
    },
    labelInput: {
      borderRadius: 17,
      backgroundColor: '#ffffff',
      border: 'none',
      boxShadow: 'none',
      padding: '15px 20px',
      width: '100%',
      boxSizing: 'border-box',
    },
    labelInputGrey: {
      borderRadius: 17,
      backgroundColor: '#f7f7f7',
      border: 'none',
      boxShadow: 'none',
      padding: '15px 20px',
      width: '100%',
      boxSizing: 'border-box',
    },

    labelParagraph: {
      marginBottom: 10,
      marginTop: 20,

      '@media (max-width: 769px)': {
        marginTop: 15,
      },
    },
    error: {
      '& .select__control': {
        borderColor: '#EE2049',
      },
      '& .error': {
        display: 'flex',
        alignItems: 'center',
        fontSize: 12,
        paddingTop: 7,
        color: '#EE2049',
      },
      '& .error img': {
        width: 12,
        height: 12,
        marginTop: 2,
        marginRight: 5,
      },
    },
  })

  const classes = useStyles()
  const isDisabled = false
  const isLoading = false
  // TODO: Toggle state for checkboxes, refer to Accordion for states

  const isSearchable = noSearch ? false : true

  return (
    <div className={`${error && classes.error}`} style={{ marginBottom: 20 }}>
      <label className={`${classes.labelWrapper} ${error && classes.error}`}>
        <Select
          className="basic-single"
          classNamePrefix="select"
          isDisabled={isDisabled}
          isLoading={isLoading}
          isClearable={true}
          isSearchable={isSearchable}
          name={inputName}
          options={optionsArray}
          placeholder={placeholder}
          styles={colourStyles}
          value={optionsArray.filter(option => option.value === defaultValue)}
          components={{
            IndicatorSeparator: () => null,
          }}
          onChange={(e, { action }) => {
            if (action === 'clear') onClear()
            else
              onChange({
                target: {
                  name: inputName,
                  value: e && e.value,
                },
              })
          }}
        />
      </label>
      {error && (
        <div className="error">
          <img src="/themes/thrifty/assets/images/errorex.png" />
          {error.join(', ')}
        </div>
      )}
    </div>
  )
}

export default FormSelect
